import { Col, DatePicker, Form, Row } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TaskDeadline } from '../Deadline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskFormDeadline = function TaskFormDeadline(_ref) {
  var isReadonly = _ref.isReadonly;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return useMemo(function () {
    return /*#__PURE__*/_jsxs(Container, {
      justify: "space-between",
      align: "middle",
      children: [/*#__PURE__*/_jsx(Col, {
        span: 14,
        className: "col-1",
        children: /*#__PURE__*/_jsx(Form.Item, {
          name: "deadline",
          label: t('form.task.deadline.label'),
          getValueProps: function getValueProps(deadline) {
            return {
              value: deadline ? moment(deadline) : null
            };
          },
          children: /*#__PURE__*/_jsx(DatePicker, {
            showTime: true,
            placeholder: isReadonly ? t('form.task.deadline.empty') : t('form.task.deadline.placeholder'),
            bordered: !isReadonly,
            disabled: isReadonly,
            format: "DD/MM/YYYY HH:mm"
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 10,
        className: "col-2",
        children: /*#__PURE__*/_jsx(Form.Item, {
          label: " ",
          shouldUpdate: true,
          children: function children(form) {
            var deadline = form.getFieldValue('deadline');
            var date = deadline ? moment(deadline).toDate() : undefined;
            return /*#__PURE__*/_jsx(TaskDeadline, {
              deadline: date
            });
          }
        })
      })]
    });
  }, [isReadonly]);
}; // Styles

var Container = styled(Row).withConfig({
  displayName: "Deadline__Container",
  componentId: "sc-c4aimr-0"
})([".col-2{text-align:right;}"]);